import { useTranslation } from 'react-i18next';

interface AbilityBar {
  key: string;
  keyEn: string;
  level: number;
  color: string;
}

export default function LivingAbilityWheel() {
  const { t } = useTranslation();

  const abilities: AbilityBar[] = [
    { key: 'integrity', keyEn: 'integrityEn', level: 9, color: 'bg-primary-400' },
    { key: 'awareness', keyEn: 'awarenessEn', level: 8, color: 'bg-accent-400' },
    { key: 'accountability', keyEn: 'accountabilityEn', level: 7, color: 'bg-secondary-400' },
    { key: 'gratitude', keyEn: 'gratitudeEn', level: 8, color: 'bg-rose-300' },
  ];

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2
          className="text-lg md:text-xl text-foreground-800 mb-2 text-center"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {t('journey.livingAbilityWheel.title')}
        </h2>
        <p className="text-xs text-foreground-400 text-center mb-8">
          {t('journey.livingAbilityWheel.subtitle')}
        </p>

        <div className="max-w-lg mx-auto space-y-5">
          {abilities.map((ab) => {
            const abilityName = t(`journey.livingAbilityWheel.abilities.${ab.key}` as any);
            const abilityNameEn = t(`journey.livingAbilityWheel.abilities.${ab.keyEn}` as any);
            const pct = (ab.level / 10) * 100;

            return (
              <div key={ab.key} className="flex items-center gap-3">
                {/* Label */}
                <div className="w-20 md:w-24 flex-shrink-0">
                  <p className="text-sm font-medium text-foreground-700">{abilityName}</p>
                  <p className="text-[10px] text-foreground-400">{abilityNameEn}</p>
                </div>

                {/* Bar */}
                <div className="flex-1 h-2.5 bg-foreground-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-700 ${ab.color}`}
                    style={{ width: `${pct}%` }}
                  />
                </div>

                {/* Tick marks */}
                <div className="flex gap-[2px] flex-shrink-0">
                  {Array.from({ length: 10 }).map((_, i) => (
                    <div
                      key={i}
                      className={`w-[5px] h-1 rounded-full ${i < ab.level ? ab.color : 'bg-foreground-200'}`}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Subtitle — Ability, not Skill */}
        <p className="text-center text-[11px] text-foreground-300 mt-8">
          這些不是技能，而是正在恢復的生命能力。
        </p>
      </div>
    </section>
  );
}